import { DataCardHeaderProps } from '../../../../models/internal_api/cardInterfaces.model';
import './DataCardHeader.scss';

export default function DataCardHeader(props: DataCardHeaderProps) {
    const iconStyle: any = {
        width: '40px',
        height: '40px',
        backgroundColor: `rgba(${props.config.circleColor}, 1)`
    };

    return (
        <div className='DataCard__header'>
            <div className='DataCard__header-icon' style={iconStyle}>
                <img src={props.config.icon.imagePath} alt={props.config.icon.altText} />
            </div>
            <div className='DataCard__header-text'>
                <p>{props.title}</p>
            </div>
        </div>
    );
}